import { Theme } from "@mui/material";

export const getCommonTransition = (theme: Theme, props: string | string[]) => {
  return theme.transitions.create(props, {
    duration: theme.transitions.duration.standard,
    easing: theme.transitions.easing.easeOut,
  });
};
